const template = document.createElement('template');
template.innerHTML = `
<style>
  .page {
    display: none;
  }

  .page.is-active {
    display: block;
  }
</style>

<div class="page" part="navigation">
  <slot></slot>
</div>
`;

class Page extends HTMLElement {
  private readonly root:HTMLDivElement|null;
  constructor() {
    super();
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.root = shadowRoot.querySelector('.page')!;

  }

  setActive(isActive) {
    this.root.classList[isActive ? 'add' : 'remove']('is-active');
  }
}


if(!customElements.get('personalisation-page')) {
  customElements.define('personalisation-page', Page);
}